import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectClientThresholdsStateAccount,
  selectTransactions,
} from 'src/selectors/clients.selector'

import { Col, Row } from 'react-bootstrap'
import { toMoney } from 'src/utils/utilities'
import { Card, Paragraph } from 'src/components'

const ClientTransactionsSummary = () => {
  const data: IClientTransactionData = useSelector(selectTransactions)

  const thresholds: IClientThresholdStateAccount[] = useSelector(
    selectClientThresholdsStateAccount,
  )
  const withThresholds = thresholds.length > 0

  const summaries: ISelect[] = [
    { label: 'Total de ventas', value: toMoney(data.sell) },
    { label: 'Pagos recibidos', value: toMoney(data.payments) },
    { label: 'Cuenta por cobrar', value: toMoney(data.balance) },
  ]

  return (
    <Row>
      {withThresholds && (
        <Col xl={4} lg={4} md={4} sm={12}>
          <Card>
            <Row>
              {thresholds.map(threshold => (
                <Col key={threshold.id} xl={12}>
                  <Paragraph style={{ color: threshold.rgb }}>
                    Total con {threshold.min}+ Días: {toMoney(threshold.amount)}
                  </Paragraph>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      )}
      <Col
        xl={withThresholds ? 8 : 12}
        lg={withThresholds ? 8 : 12}
        md={withThresholds ? 6 : 12}
        sm={12}>
        <Row>
          {summaries.map(summary => (
            <Col key={summary.label}>
              <Card>
                <Paragraph>{summary.label}</Paragraph>
                <Paragraph size={'big'} bold>
                  {summary.value}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  )
}
export default ClientTransactionsSummary
